import { ArrowUpIcon, ArrowDownIcon } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

interface DeltaIndicatorProps {
    deltaPercent: number | null;
    previousLabel: string;
}

export function DeltaIndicator({
    deltaPercent,
    previousLabel,
}: DeltaIndicatorProps) {
    if (deltaPercent === null) {
        return (
            <span className="text-xs text-grey-400 leading-5">
                &mdash; {previousLabel}
            </span>
        );
    }
    const isUp = deltaPercent > 0;
    const isDown = deltaPercent < 0;
    const colorClass = isUp
        ? 'text-green-bright'
        : isDown
          ? 'text-danger-200'
          : 'text-grey-400';
    const ArrowIcon = isUp ? ArrowUpIcon : isDown ? ArrowDownIcon : null;
    return (
        <span
            className={cn(
                'text-xs leading-5 flex items-center gap-1',
                colorClass,
            )}
        >
            {ArrowIcon && <ArrowIcon className="size-3" weight="bold" />}
            <span>
                {Math.abs(deltaPercent).toFixed(1)}% {previousLabel}
            </span>
        </span>
    );
}
